module.exports = __webpack_public_path__ + "static/media/travesseirocarne.45453a57.webp";